/* Modulo Section: Media & Tabs — accordion + lazy video */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  function initTabs(section) {
    var tabsRoot = section.querySelector('[data-modulo-mt-tabs]');
    if (!tabsRoot) return;
    var autoClose = section.getAttribute('data-auto-close') !== 'false';
    var tabs = tabsRoot.querySelectorAll('[data-modulo-mt-tab]');

    tabs.forEach(function (tab) {
      var trigger = tab.querySelector('[data-modulo-mt-trigger]');
      if (!trigger) return;
      trigger.addEventListener('click', function () {
        var isOpen = tab.getAttribute('data-open') === 'true';
        if (autoClose && !isOpen) {
          tabs.forEach(function (other) {
            if (other !== tab) {
              other.setAttribute('data-open', 'false');
              var otherBtn = other.querySelector('[data-modulo-mt-trigger]');
              if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
            }
          });
        }
        tab.setAttribute('data-open', isOpen ? 'false' : 'true');
        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });
  }

  function initVideo(section) {
    var videoEl = section.querySelector('[data-modulo-mt-video]');
    if (!videoEl) return;
    var playBtn = videoEl.querySelector('.modulo-mt__play');
    if (!playBtn) return;

    playBtn.addEventListener('click', function () {
      var provider = videoEl.getAttribute('data-provider');
      var videoId = videoEl.getAttribute('data-video-id');
      if (!videoId) return;

      var iframe = document.createElement('iframe');
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('loading', 'lazy');
      iframe.setAttribute('title', 'Video player');

      if (provider === 'youtube') {
        iframe.src = 'https://www.youtube.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1&rel=0';
      } else if (provider === 'vimeo') {
        iframe.src = 'https://player.vimeo.com/video/' + encodeURIComponent(videoId) + '?autoplay=1';
      } else {
        return;
      }

      videoEl.classList.add('is-playing');
      videoEl.appendChild(iframe);
    });
  }

  function initSection(section) {
    initTabs(section);
    initVideo(section);
  }

  function bootstrap() {
    if (window.moduloLazyInit) {
      window.moduloLazyInit('[data-modulo-mt]', initSection);
    } else {
      var els = document.querySelectorAll('[data-modulo-mt]');
      for (var i = 0; i < els.length; i++) initSection(els[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
